(function () {
    function getAllUrlParams(url)
    {
        var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
        var obj = {};

        if (queryString) {
            queryString = queryString.split('#')[0];
            var arr = queryString.split('&');

            for (var i = 0; i < arr.length; i++) {
                var a = arr[i].split('=');
                var paramNum = undefined;
                var paramName = a[0].replace(/\[\d*\]/, function (v) {
                    paramNum = v.slice(1, -1);
                    return '';
                });

                var paramValue = typeof (a[1]) === 'undefined' ? '' : a[1];
                paramValue = String(paramValue);
                paramName = sanitizeKey(paramName.toLowerCase());
                paramValue = paramValue.toLowerCase();


                if (obj[paramName]) {
                    if (typeof obj[paramName] === 'string') {
                        obj[paramName] = [obj[paramName]];
                    }

                    if (typeof paramNum === 'undefined') {
                        obj[paramName].push(paramValue);
                    } else {
                        obj[paramName][paramNum] = paramValue;
                    }

                } else {
                    obj[paramName] = paramValue;
                }
            }
        }

        return obj;
    }

    const sanitizeKey = function(t) {
        return t && ["__proto__", "constructor", "prototype"].includes(t.toLowerCase()) ? t.toUpperCase() : t;
    }

    const utm_tags = {
        utm_source: 'utm_source',
        utm_medium: 'utm_medium',
        utm_campaign: 'utm_campaign',
        utm_content: 'utm_content',
        utm_term: 'utm_term',
    }

    var date = new Date;
    date.setDate(date.getDate() + 30);
    date = date.toUTCString();
    var url = document.location.href;
    var getUrlObj = getAllUrlParams(url);

    for (var key in getUrlObj) {
        if (key in utm_tags) {
            document.cookie = key + '=' + getUrlObj[key] + ';path=/; expires=' + date;
        }
    }
})();
